"use client"
import { Swiper } from "mondrian-react"
// import Script from "next/script"
import { useEffect } from "react";
import { reportGA4 } from "utils/pushDataLayer";
import "./styles.scss";

const SliderItem = ({id, classs}) => {
  return <div title={id} className={`sliderItem ${classs} overflow-hidden block`} id={id}></div>
}

export default function AdCarrossel({conta, canal, larguraDesktop, alturaDesktop, larguraCelular, alturaCelular, breakPoint, totalSlides}) {
  useEffect(() => {
    let count = {};
    let slidesQtd = [];
    const allSlosts = ["_slot1", "_slot2", "_slot3", "_slot4", "_slot5", "_slot6", "_slot7", "_slot8", "_slot9", "_slot10"]
    window.googletag = window.googletag || { cmd: [] };
    window.googletag.cmd.push(function () {
      var mapping1 = window.googletag.sizeMapping().addSize([breakPoint, 0], [[larguraDesktop, alturaDesktop]]).addSize([0, 0], [[larguraCelular, alturaCelular]]).build();

      window.googletag.defineSlot(`/${conta}/${canal}_1`, [[larguraDesktop, alturaDesktop], [larguraCelular, alturaCelular]], `${canal}_slot1`).defineSizeMapping(mapping1).addService(window.googletag.pubads());
      window.googletag.defineSlot(`/${conta}/${canal}_2`, [[larguraDesktop, alturaDesktop], [larguraCelular, alturaCelular]], `${canal}_slot2`).defineSizeMapping(mapping1).addService(window.googletag.pubads());
      window.googletag.defineSlot(`/${conta}/${canal}_3`, [[larguraDesktop, alturaDesktop], [larguraCelular, alturaCelular]], `${canal}_slot3`).defineSizeMapping(mapping1).addService(window.googletag.pubads());
      window.googletag.defineSlot(`/${conta}/${canal}_4`, [[larguraDesktop, alturaDesktop], [larguraCelular, alturaCelular]], `${canal}_slot4`).defineSizeMapping(mapping1).addService(window.googletag.pubads());
      window.googletag.defineSlot(`/${conta}/${canal}_5`, [[larguraDesktop, alturaDesktop], [larguraCelular, alturaCelular]], `${canal}_slot5`).defineSizeMapping(mapping1).addService(window.googletag.pubads());
      window.googletag.defineSlot(`/${conta}/${canal}_6`, [[larguraDesktop, alturaDesktop], [larguraCelular, alturaCelular]], `${canal}_slot6`).defineSizeMapping(mapping1).addService(window.googletag.pubads());
      window.googletag.defineSlot(`/${conta}/${canal}_7`, [[larguraDesktop, alturaDesktop], [larguraCelular, alturaCelular]], `${canal}_slot7`).defineSizeMapping(mapping1).addService(window.googletag.pubads());
      window.googletag.defineSlot(`/${conta}/${canal}_8`, [[larguraDesktop, alturaDesktop], [larguraCelular, alturaCelular]], `${canal}_slot8`).defineSizeMapping(mapping1).addService(window.googletag.pubads());
      window.googletag.defineSlot(`/${conta}/${canal}_9`, [[larguraDesktop, alturaDesktop], [larguraCelular, alturaCelular]], `${canal}_slot9`).defineSizeMapping(mapping1).addService(window.googletag.pubads());
      window.googletag.defineSlot(`/${conta}/${canal}_10`, [[larguraDesktop, alturaDesktop], [larguraCelular, alturaCelular]], `${canal}_slot10`).defineSizeMapping(mapping1).addService(window.googletag.pubads());
      
      window.googletag.pubads().enableSingleRequest();
      window.googletag.pubads().collapseEmptyDivs();
      window.googletag.pubads().setForceSafeFrame(false);
      window.googletag.enableServices();

      //Inicia a chamada dos anúncios
      for (let index = 1; index < totalSlides; index++) {
        window.googletag.cmd.push(function() { window.googletag.display(`${canal}_slot${index}`); });
      }

      //Evento disparado quando recebe uma resposta de cada chamada de anúncio.
      window.googletag.pubads().addEventListener("slotResponseReceived", (event) => {
        const slot = event.slot;
        slot.getResponseInformation() === null ? console.log(slot.getSlotElementId() + " - 🔴") : console.log(slot.getSlotElementId() + " - 🟢");

        //Remove todos os slots que não receberam anúncios
        slot.getResponseInformation() === null && document.getElementById(slot.getSlotElementId()) && document.getElementById(slot.getSlotElementId()).parentElement.remove();
      });

          


      //Evento disparado a cada anúncio carregado.
      window.googletag.pubads().addEventListener("slotOnload", function (event) {
        const slot = event?.slot;
        console.log(slot.getSlotElementId(), " ✅ ");
        const cannal = slot.getSlotElementId().split("_slot")[0];

        //Quando o primeiro anúncio é carregado o carrossel fica visivel em tela. Se não ele permanece oculto.
        if (document.querySelector(`#${cannal}`)) {
          document.querySelector(`#${cannal}`).classList.remove("hidden");
        }

        //Seleciona o IFRAME antes de manipular elementos dentro dele
        const slotIframe = document.getElementById(slot.getSlotElementId()).querySelector("iframe");

        if (slotIframe.querySelector('body')) {
          slotIframe.querySelector('body').style.display = 'flex';
          slotIframe.querySelector('body').style.alignItems = 'flex-end';
          slotIframe.querySelector('body').style.justifyContent = 'center';
        }

        if (slotIframe.contentWindow.document.getElementById('google_image_div')) {
          const imagem = slotIframe?.contentWindow?.document?.getElementById('google_image_div').querySelectorAll("img");
          for (let item of imagem) {
            item.style.width = '100%';
            item.style.height = 'auto';
            item.style.position = "relative";
          }
        }
            
        if (slotIframe.contentWindow.document.getElementsByClassName("GoogleActiveViewElement")) {
          const googleActiveViewElement = slotIframe.contentWindow.document.getElementsByClassName("GoogleActiveViewElement");
          for (let item of googleActiveViewElement) {
            item.style.width = '100%';
            item.style.height = 'auto';
            item.style.position = "relative";
            
            const hasListener = item.getAttribute('ga4Listener');

            if (hasListener === null || hasListener === 'false') {
              item.addEventListener('click', (ev) => {
                ev.stopPropagation();
                reportGA4({ customTitle: `banner_ads_${slot.getSlotElementId()}` });
              });
              
              item.setAttribute('ga4Listener', 'true');
            }
          }
        }
            
        if (slotIframe.contentWindow.document.getElementsByClassName("cbb")) {
          const btClose = slotIframe.contentWindow.document.getElementsByClassName("cbb");
          for (let item of btClose) {
            item.style.display = "none";
          }
        }

        if (slotIframe.contentWindow.document.getElementsByClassName("abgc")) {
          const btInfo = slotIframe.contentWindow.document.getElementsByClassName("abgc");
          for (let item of btInfo) {
            item.style.display = "none";
          }
        }
            
        if (slotIframe.contentWindow.document.getElementsByClassName("abgcp")) {
          const abgcp = slotIframe.contentWindow.document.getElementsByClassName("abgcp");
          for (let item of abgcp) {
            item.style.display = "none";
          }
        }

        if (slotIframe.contentWindow.document.getElementsByClassName("videoAdUiIconV2")) {
          const videoAdUiIconV2 = slotIframe.contentWindow.document.getElementsByClassName("videoAdUiIconV2");
          for (let item of videoAdUiIconV2) {
            item.style.display = "none";
          }
        }

        if (slotIframe.contentWindow.document.querySelectorAll("#google_center_div")) {
          const googleCenterDiv = slotIframe?.contentWindow?.document?.querySelectorAll("#google_center_div");
          for (let item of googleCenterDiv) {
            item.style.verticalAlign = "bottom";
          }	
        }
            
        if (slotIframe.contentWindow.document.querySelectorAll("div[data-nc='1']")) {
          const dataNc = slotIframe.contentWindow.document.querySelectorAll("div[data-nc='1']");
          for (let item of dataNc) {
            item.style.display = "flex";
          }
        }

        if (slotIframe.contentWindow.document.querySelector(".GoogleCreativeContainerClass")) {
          slotIframe.contentWindow.document.querySelector(".GoogleCreativeContainerClass > img").style.display = "flex";
        }

        //Retorna o nome do canal que é igual ao um carrossel na tela
        let getNomeCanal = function (element) {
          for (const key in allSlosts) {
            if (element.includes(allSlosts[key])) {
              let value =  element.replace(allSlosts[key], "");
              return value
            }
          }
        }

        // Seleciona o carrossel atual
        let nomeCanal = getNomeCanal(slot.getSlotElementId());

        // Atribui um valor pra esse carrossel
        let value = count[nomeCanal] === undefined ? 1 : count[nomeCanal] + 1;

        //Seta o valor ao objeto do carrossel
        count[nomeCanal] = value;

        //Remove a navBar do Carrossel se ele tiver apenas um slide
        const hasSlide = slidesQtd.find(i => i === slot.getSlotElementId())
        if (!hasSlide) {
          slidesQtd.push(slot.getSlotElementId())
        }

        if (slidesQtd <= 1) {
          for (const key in count) {
            const navCarrossel = document.querySelector(`#${key}`).querySelectorAll(".mdn-SwiperSlide-pagination")[0];
            count[key] <= 1 ? navCarrossel.style.display = "none" : navCarrossel.style.display = "block";
          }
        }
      });



      // PAGE RESIZE Atualiza os anúncios pro caso de mudar a largura da tela entre desktop e celular
      let timeOutFunction;
      window.addEventListener("resize", function () {
        clearTimeout(timeOutFunction);
        timeOutFunction = setTimeout(() => {
          count = undefined;
          window.googletag.pubads().refresh();

        }, 500);
      });
    });
  }, [alturaCelular, alturaDesktop, breakPoint, canal, conta, larguraCelular, larguraDesktop, totalSlides]);

  return (
    <div className="gam-wrapper mdn-Container">
      {
        <div id={canal}>
          <Swiper slidesPerView={1} bullets autoplay>
            <SliderItem id={`${canal}_slot1`} classs={canal}/>
            <SliderItem id={`${canal}_slot2`} classs={canal}/>
            <SliderItem id={`${canal}_slot3`} classs={canal}/>
            <SliderItem id={`${canal}_slot4`} classs={canal}/>
            <SliderItem id={`${canal}_slot5`} classs={canal}/>
            <SliderItem id={`${canal}_slot6`} classs={canal}/>
            <SliderItem id={`${canal}_slot7`} classs={canal}/>
            <SliderItem id={`${canal}_slot8`} classs={canal}/>
            <SliderItem id={`${canal}_slot9`} classs={canal}/>
            <SliderItem id={`${canal}_slot10`} classs={canal}/>
          </Swiper>
        </div>
      }

      <style jsx="true" global="true">{`
        .${canal}, .${canal} > div{
          display: flex;
          justify-content: center;
          width: 100%
        }

        .mdn-Swiper--bullets .swiper-pagination-bullets {
          margin-top: 1.5rem !important
        }

        .mdn-Swiper--bullets .swiper-pagination-bullet {
          width: 2.5rem !important;
          height: 0.25rem !important;
          margin: 0 0.25rem !important;
        }

        .mdn-Swiper--bullets .swiper-pagination-bullet-active {
          max-width: 3rem !important;
        }

        .${canal} iframe{
          border-radius: 16px;
        }
      `}</style>
    </div>
  )
}
